<template>
    <span :class="[$style.status, status && $style[statusStr]]" v-if="!!statusStr">
        <span style="color: #8993a4">{{ $t('common.status_' + statusStr) }}</span>
    </span>
</template>

<script lang="ts">
export default {
    name: 'ItemStatus'
};
</script>

<script lang="ts" setup>
import { computed } from 'vue';
import type { AssetStatusType } from '@landingPage/static/types/page.type';
interface Props {
    status: AssetStatusType;
}
const props = defineProps<Props>();
const statusStr = computed(() => {
    return props.status?.toLocaleLowerCase();
});
</script>

<style lang="scss" module>
@import '@style/import.scss';
.status {
    display: inline-flex;
    align-items: center;
    font-size: 12px;
    height: 20px;
    line-height: 20px;
    padding: 0 8px;
    border-radius: 2px;
    white-space: nowrap;
    position: relative;
    padding-left: 12px;

    &::before {
        content: '';
        width: 8px;
        height: 8px;
        border-radius: 50%;
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
    }

    &.running {
        color: $pt-green5;

        &::before {
            background-color: $pt-green5;
        }
    }

    &.pause,
    &.draft {
        color: $pt-grey4;

        &::before {
            background-color: #8993a4;
        }
    }

    &.scheduled {
        color: #efbb33;

        &::before {
            background-color: #efbb33;
        }
    }
}
</style>
